import classNames from 'classnames'
import type { ReactNode } from 'react'
import Text from '@/stories/components/Common/NewText'
import { yieldToMain } from '@/root/utils/yield-to-main'

export function Chip({
  children,
  isActive = false,
  onClick = () => null,
}: {
  children: ReactNode
  isActive?: boolean
  onClick: (e) => void
}) {
  return (
    <button
      type="button"
      className={classNames(
        `cursor-pointer rounded-lg px-2.5 py-1.5 text-center`,
        {
          'bg-brand-blue-azureRadiance text-brand-white': isActive,
          'bg-brand-tertiary-grey text-brand-grey-dark': !isActive,
        },
      )}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

interface HorizontalNavigationProps {
  data: Array<{ selected: boolean; title: string; subTitle?: string }>
  onSelect: (title: string, e) => void
}
export default function Chicklets(props: HorizontalNavigationProps) {
  const { data, onSelect } = props

  return (
    <div className="flex flex-row flex-wrap gap-2">
      {data.map(chip => (
        <Chip
          isActive={chip.selected}
          onClick={async e => {
            await yieldToMain()
            onSelect(chip.title, e)
          }}
          key={chip.title}
        >
          <div className="flex h-full flex-col items-center justify-center md:flex-row">
            <Text appearance="subtitle1">{chip.title}</Text>
            {chip.subTitle && (
              <Text appearance="subtitle2" addClassName="ml-2" tag="span">
                {chip.subTitle}
              </Text>
            )}
          </div>
        </Chip>
      ))}
    </div>
  )
}
